<template>
  <v-text v-show="isActive">
    <slot :active="isActive"/>
  </v-text>
</template>

<script>
export default {
  data() {
    return {
      isActive: this.active
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
